import React, { memo, useCallback } from 'react'

import { Radio } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

import { getLibraryFilterUpdaterFunction } from 'Pods/ThreeDStudio/Shared/Utils'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

function FilteringRadio({ id, keyName, label }) {
  const isChecked = useThreeDStudioStore(state => state.libraryFilter.includes(keyName))

  const handleChange = useCallback(value => {
    getLibraryFilterUpdaterFunction(value)(keyName)
  }, [])

  return (
    <Radio
      id={id}
      label={label}
      isChecked={isChecked}
      onChange={handleChange}
      checkedColor="primary"
      size="small"
    />
  )
}

FilteringRadio.propTypes = {
  id: string.isRequired,
  keyName: string.isRequired,
  label: string.isRequired,
}

export default memo(FilteringRadio)
